var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    {
      staticClass: "items",
      nativeOn: {
        contextmenu: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.openContextMenu($event)
        },
      },
    },
    [
      _c(
        "w-col",
        {
          nativeOn: {
            drop: function ($event) {
              $event.preventDefault()
              return _vm.onDrop($event)
            },
          },
        },
        [
          _c(
            "transition-group",
            { attrs: { tag: "div", name: "fade" } },
            _vm._l(_vm.topLevelGroups, function (group, i) {
              return _c("app-product-group-edit-node", {
                key: group.getUid(),
                attrs: {
                  "is-first-item": i == 0,
                  path: `${i}`,
                  value: group,
                  "is-top-level-group": "",
                },
                on: {
                  move: _vm.doMove,
                  remove: function ($event) {
                    return _vm.removeGroup(i)
                  },
                },
              })
            }),
            1
          ),
          _c(
            "w-link",
            {
              staticClass: "add-button",
              class: { "no-border": _vm.topLevelGroups.length == 0 },
              attrs: { disabled: !_vm.canEdit },
              on: {
                click: function ($event) {
                  return _vm.createNewGroup()
                },
              },
            },
            [
              _c("w-fa", { staticClass: "icon", attrs: { icon: "plus" } }),
              _vm._v(" " + _vm._s(_vm.$ct("new-product-group")) + " "),
            ],
            1
          ),
          _vm.topLevelGroups.length == 0
            ? _c("w-col", { staticClass: "empty" }, [
                _vm._v(" " + _vm._s(_vm.$ct("no-product-groups")) + " "),
              ])
            : _vm._e(),
          _vm.isContextMenuOpen
            ? _c("app-context-menu", {
                attrs: {
                  value: _vm.contextMenuOpen,
                  x: _vm.contextMenuX,
                  y: _vm.contextMenuY,
                  "can-add-sub-group": true,
                },
                on: {
                  new: function ($event) {
                    return _vm.createNewGroup()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }